import { render } from "./FacilityBookingPage.vue?vue&type=template&id=37acacae"
import script from "./FacilityBookingPage.vue?vue&type=script&lang=js"
export * from "./FacilityBookingPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/mali/APP_FCCBookingApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__